document.addEventListener('DOMContentLoaded', function () {
	const images = document.querySelectorAll('.hero-small-images__image');
	if (images.length > 0) {
		const arrow = document.querySelector('.hero-small-images__arrow');
		const title = document.querySelector('.hero-small-images__title');
		const btn = document.querySelector('.button--hero-small-images');
		const btnText = document.querySelector(
			'.button__after-text--hero-small-images'
		);

		const intersectionCallback = (entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					images.forEach(image => image.classList.add('scale-up'));
					arrow.classList.add('scale-up');
					title.classList.add('scale-up');
					btn.classList.add('scale-up');
					btnText.classList.add('scale-up');
					observer.unobserve(entry.target);
				}
			});
		};

		const observer = new IntersectionObserver(intersectionCallback);

		images.forEach(image => observer.observe(image));
		observer.observe(arrow);
		observer.observe(title);
		observer.observe(btn);
		observer.observe(btnText);
	}
});
